module.exports = __webpack_public_path__ + "img/5.6716d3ab.png";